import { getJsonOrError } from '../../utils/fetch'
import { queryString } from '../../utils/window'
import {
  getApiServicesEndpoints,
  getPageLocale,
  getSite,
  getPostCategories,
} from '../../application/pageDataObject'
import { getCountryCode } from '../../providers/geolocationProvider'

const getDate = () => {
  const date = queryString.localTime
    ? new Date(queryString.localTime)
    : new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
  date.setSeconds(0, 0)
  return date.toJSON()
}

const getLocale = () => queryString.language || getPageLocale()

const getTags = () => queryString.tags || getPostCategories().join(',')

const getCampaignsFromCampaignManagerService = async (site, country, localTime, locale, tags) => {
  const result = await getJsonOrError(
    `${getApiServicesEndpoints()
      .campaigns}?site=${site}&country=${country}&localTime=${localTime}&language=${locale}&tags=${tags}`
  )
  return result.data
}

let campaignsPromise = null

export const getCampaignsFromCampaignManager = async () => {
  const countryCode = await getCountryCode()
  if (!campaignsPromise) {
    campaignsPromise = getCampaignsFromCampaignManagerService(
      getSite(),
      countryCode,
      getDate(),
      getLocale(),
      getTags()
    )
  }

  return await campaignsPromise
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/campaigns/campaignManagerProvider.js